import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export const sortDigitsAlpha = (items) => {
  return Array.from(new Set(items))
    .filter((name) => name !== "")
    .sort((a, b) => {
      if (/^\d/.test(a) && !/^\d/.test(b)) {
        return -1;
      } else if (!/^\d/.test(a) && /^\d/.test(b)) {
        return 1;
      } else {
        return a.localeCompare(b);
      }
    });
};
export const setUnique = (items, key) => {
  const uniqueValues = [
    ...new Set(
      items.filter((item) => item[key] !== "").map((item) => item[key])
    ),
  ];

  return uniqueValues.map((value) => ({
    label: value,
    value,
  }));
};

export const sortAlpha = (arr) => {
  return arr.sort((a, b) => a.label.localeCompare(b.label));
};
export const finderSelectStyles = {
  control: (provided) => ({
    ...provided,

    paddingBottom: "150px",
    width: "280px",
    border: "none",
  }),
  placeholder: (provided) => ({
    ...provided,
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "0",
      height: "0",
      borderLeft: "8px solid transparent",
      borderRight: "8px solid transparent",
      borderTop: "8px solid black",
      cursor: "pointer",
    },
  }),
};

export const exportToExcel1 = (columnMap, tableInstance, rows, screen) => {
  // Get current date in DD-MM-YYYY format
  const currentDate = new Date()
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");

  // Dynamic filename
  const filename = `LXRPManagementDashboardTool_${screen}_Finder_Results_${currentDate}.xlsx`;

  // Get visible columns from React Table instance
  const visibleColumns = tableInstance.columns.filter((col) => col.show);

  // Create header map only for visible columns from columnMap
  const headerMap = visibleColumns.reduce((acc, col) => {
    acc[col.id] = columnMap[col.id]?.label || col.id; // Get label from columnMap
    return acc;
  }, {});

  // Function to create a colored circle (Commented for future use)
  // const createColoredCircle = (color) => {
  //   return {
  //     v: "RAG ●", // Unicode for a circle symbol
  //     s: {
  //       font: {
  //         sz: 16, // Size of the circle
  //         color: { rgb: "000000" }, // White text color for "RAG"
  //       },
  //       alignment: { horizontal: "center", vertical: "center" },
  //       fill: { fgColor: { rgb: color } }, // Background color
  //     },
  //   };
  // };

  // Prepare header row with colored circles for RAG columns
  const headerRow = Object.keys(headerMap).map((key) => {
    const label = headerMap[key];
    let cellValue = label;

    // Add colored circle for RAG columns (Commented for future use)
    // if (key === "ragGreen") {
    //   cellValue = createColoredCircle("008000"); // Green for RAG
    // } else if (key === "ragOrange") {
    //   cellValue = createColoredCircle("FFA500"); // Orange for RAG
    // } else if (key === "ragRed") {
    //   cellValue = createColoredCircle("FF4500"); // Red for RAG
    // }

    return cellValue;
  });

  // Transform rows to match only visible columns
  const formattedData = rows.map((row) =>
    Object.keys(row.original)
      .filter((key) => headerMap[key]) // Include only visible columns
      .reduce((acc, key) => {
        acc[headerMap[key]] = row.original[key]; // Use mapped label
        return acc;
      }, {})
  );

  // Create the worksheet
  const ws = XLSX.utils.json_to_sheet(formattedData, {
    header: Object.values(headerMap),
  });

  // Add the header row with the colored circles
  XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: "A1" });

  // Set column widths based on columnMap
  ws["!cols"] = visibleColumns.map((col) => {
    const width = columnMap[col.id]?.width || 10; // Default width of 10
    return { wpx: width * 10 }; // Adjust the width in pixels
  });

  // Create the workbook and export
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, filename);
};

export const exportToExcel = async (columnMap, tableInstance, rows, screen) => {
  const currentDate = new Date()
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");
  const filename = `LXRPManagementDashboardTool_${screen}_Finder_Results_${currentDate}.xlsx`;

  const visibleColumns = tableInstance.columns.filter((col) => col.show);
  const headerMap = visibleColumns.reduce((acc, col) => {
    acc[col.id] = columnMap[col.id]?.label || col.id;
    return acc;
  }, {});

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  // Define columns with word wrapping
  worksheet.columns = visibleColumns.map((col) => ({
    header: headerMap[col.id],
    key: col.id,
    width: (columnMap[col.id]?.width || 10) * 1.5, // Adjust width
    style: { alignment: { wrapText: true } }, // ✅ Word wrap enabled
  }));
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  //headerRow.alignment = { horizontal: "center", vertical: "middle" };
  headerRow.height = 30;

  // Add rows
  rows.forEach((row) => {
    const rowData = {};
    Object.keys(row.original)
      .filter((key) => headerMap[key])
      .forEach((key) => {
        rowData[key] = row.original[key];
      });
    worksheet.addRow(rowData);
  });

  // Apply color to the entire column based on the colorHead property
  visibleColumns.forEach((col, colIndex) => {
    if (columnMap[col.id]?.colorHead) {
      const colColor = columnMap[col.id].colorHead;
      worksheet.getColumn(colIndex + 1).eachCell((cell, rowNumber) => {
        if (rowNumber > 1) { // Skip header row
          cell.font = { color: { argb: colColor } };
        }
      });
    }
  });

  // Apply dynamic text color based on the cell value
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1) { // Skip header row
      row.eachCell((cell, colNumber) => {
        const col = visibleColumns[colNumber - 1];
        const value = cell.value;

        if (columnMap[col.id]?.color) {
          if (value === "Red") {
            cell.font = { color: { argb: "FFFF4500" } }; // Red color
          } else if (value === "Amber") {
            cell.font = { color: { argb: "FFFFA500" } }; // Amber color
          } else if (value === "Green") {
            cell.font = { color: { argb: "FF008000" } }; // Green color
          }
        }
      });
    }
  });

  // Generate the Excel file and trigger download
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};

export const multiValueFilter = (rows, columnId, filterValue) => {
  if (filterValue.length === 0) {
    return rows;
  }

  return rows.filter((row) => {
    const columnValues = String(row.original[columnId]).split(",");
    return columnValues.some((value) => filterValue.includes(value.trim()));
  });
};
